import { type BaseCustomerUser } from 'services/assist-api/entities/customer-user/types';
import type { TestInstanceResponseMarkWithActiveMarkerAndResponse } from 'services/assist-api/entities/test-instance-response-mark/types';
import { type TestInstanceResponseMarkerWithCustomerUser } from 'services/assist-api/entities/test-instance-response-marker/types';
import type { TestInstanceUserWithCustomerUserAndResponses } from 'services/assist-api/entities/test-instance-user/test-instance-users';
import { type MarkRow } from './types';

export function generateMarkRow(
  mark: TestInstanceResponseMarkWithActiveMarkerAndResponse,
  markers: TestInstanceResponseMarkerWithCustomerUser[],
  markerOrganisationUsers: BaseCustomerUser[],
  learnerTestInstanceUsers: TestInstanceUserWithCustomerUserAndResponses[]
): MarkRow {
  const marker = markers.find((mkr) => mark.activeMarker?.id === mkr.id);
  const markerOrganisationUser = markerOrganisationUsers.find((ou) => ou.id === marker?.user.id);

  const learnerTestInstanceUser = learnerTestInstanceUsers.find((ltiu) => {
    const responseId = ltiu.responses?.at(0)?.id;
    return responseId === mark.testInstanceResponse.id;
  });

  return {
    nsn: learnerTestInstanceUser?.user.identifier || '', // NSN can be populated after initial table is loaded.
    responseId: mark.testInstanceResponse.id,
    mark,
    marker: {
      id: marker?.id,
      organisationUser: markerOrganisationUser
    },
    status: mark.status
  };
}
